// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_9cb13c87","outerContainer":"_633c09c4","secondaryToolbar":"_91d75c3d","doorHangerRight":"_80b84d6d","toolbarContainer":"_7ad9807b","toolbarViewerMiddle":"_8eabda9e","progressBar":"_07a965ab","back-to-application":"_1450a88b","root":"_2f7ef285","leftSideWrapper":"c0b0694b","contentCard":"da9e3e68","title":"_6e29c1c6","date":"db4443e8","rightSideWrapper":"fdea140d","iconDownload":"b20992f8","iconView":"_108f25a1","titleWrapper":"c1c3d2da","privacyIcon":"_75697b18"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/HealthRecordCard/index.styl
// module id = 5047
// module chunks = 39